var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useCallback, useEffect } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { localCache } from '../localMessagsCache';
import { handleEventsFromLivePerson } from './handleLivePersonMessage';
import { submitMessageToLivePerson } from './submitLivePersonMessage';
import { EVENT_TYPE, MESSAGE_TYPE } from './constantsLivePerson';
import { handleCloseEvent } from './handleCloseEvent';
var livePersonEventSource;
export var useLivePersonConnectionRequest = function (_a) {
    var chatMessages = _a.chatMessages, setChatMessage = _a.setChatMessage, setIsDisablingInputValue = _a.setIsDisablingInputValue, setLivePersonAgentInitial = _a.setLivePersonAgentInitial, setLivePersonAgentName = _a.setLivePersonAgentName, setStreamingText = _a.setStreamingText, setErrorMessage = _a.setErrorMessage, lpUserFirstName = _a.lpUserFirstName, lpUserLastName = _a.lpUserLastName, setCachedMessages = _a.setCachedMessages, setLivePersonConversationId = _a.setLivePersonConversationId, _b = _a.livePersonOptions, livePersonOptions = _b === void 0 ? {} : _b, isLivePersonEnabled = _a.isLivePersonEnabled, setIsLivePersonEnabled = _a.setIsLivePersonEnabled, livePersonConversationId = _a.livePersonConversationId, chatSummary = _a.chatSummary, isLivePersonSessionActive = _a.isLivePersonSessionActive, setIsLivePersonSessionActive = _a.setIsLivePersonSessionActive, closeLpChat = _a.closeLpChat, setCloseLpChat = _a.setCloseLpChat, livePersonAgentName = _a.livePersonAgentName;
    var syncLivePersonChatMessage = function () {
        setChatMessage(__spreadArray([], localCache.getLocalMessages(), true));
    };
    var submitMessageURL = livePersonOptions.submitMessageURL, livePersonEventSubscriptionURL = livePersonOptions.livePersonEventSubscriptionURL, handleLivePersonOnMessageError = livePersonOptions.handleLivePersonOnMessageError, productId = livePersonOptions.productId, chatCustomerId = livePersonOptions.chatCustomerId, initiateAgentlog = livePersonOptions.initiateAgentlog;
    useEffect(function () {
        var requestOptions = {
            url: submitMessageURL,
            headers: {},
        };
        var user = {
            firstName: lpUserFirstName,
            lastName: lpUserLastName,
        };
        if (chatSummary && livePersonConversationId && !isLivePersonSessionActive) {
            var baseLpData = {
                messageType: MESSAGE_TYPE.MESSAGE,
                conversationId: livePersonConversationId,
                eventType: EVENT_TYPE.ContentEvent,
            };
            // Submit chatSummary to LP service, so the agent knows the previous conversation
            submitMessageToLivePerson({
                requestOptions: requestOptions,
                livePersonMessagePayload: {
                    chatCustomerId: chatCustomerId,
                    user: user,
                    lpData: __assign(__assign({}, baseLpData), { eventDesc: "Previous conversation summary with bot: ".concat(chatSummary), type: 'SUMMARY' }),
                    msgId: uuidV4(),
                },
                handleLivePersonOnMessageError: handleLivePersonOnMessageError,
            });
            submitMessageToLivePerson({
                requestOptions: requestOptions,
                livePersonMessagePayload: {
                    chatCustomerId: chatCustomerId,
                    user: user,
                    lpData: __assign(__assign({}, baseLpData), { eventDesc: JSON.stringify(localCache.getLocalPrompts()), type: 'TRANSCRIPT' }),
                    msgId: uuidV4(),
                },
                handleLivePersonOnMessageError: handleLivePersonOnMessageError,
            });
        }
        else if (closeLpChat && livePersonConversationId && isLivePersonSessionActive) {
            submitMessageToLivePerson({
                requestOptions: requestOptions,
                livePersonMessagePayload: {
                    chatCustomerId: chatCustomerId,
                    user: user,
                    lpData: {
                        messageType: MESSAGE_TYPE.CLOSE,
                        conversationId: livePersonConversationId,
                    },
                    msgId: uuidV4(),
                },
                handleLivePersonOnMessageError: handleLivePersonOnMessageError,
            });
            handleCloseEvent({
                livePersonAgentNickname: livePersonAgentName,
                setIsLivePersonSessionActive: setIsLivePersonSessionActive,
                setIsLivePersonEnabled: setIsLivePersonEnabled,
                setCloseLpChat: setCloseLpChat,
                livePersonEventSource: livePersonEventSource,
                setLivePersonAgentName: setLivePersonAgentName,
                setLivePersonAgentInitial: setLivePersonAgentInitial,
                setStreamingText: setStreamingText,
                setCachedMessages: setCachedMessages,
                syncChatMessage: syncLivePersonChatMessage,
            });
        }
    }, [livePersonConversationId, chatSummary, isLivePersonSessionActive, closeLpChat, livePersonAgentName]);
    return useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var subscriptionURL, oldSource, eventSourceOptions, lpData, livePersonMessagePayload, requestOptions, submitOPENMessageOptions, errorMessage, contentSeparatorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isLivePersonEnabled && lpUserFirstName && lpUserLastName && !isLivePersonSessionActive)) return [3 /*break*/, 3];
                    setIsLivePersonSessionActive(true);
                    setIsDisablingInputValue(true);
                    subscriptionURL = "".concat(livePersonEventSubscriptionURL, "?chatCustomerId=").concat(chatCustomerId);
                    if (livePersonEventSource) {
                        oldSource = livePersonEventSource;
                        oldSource.close();
                    }
                    livePersonEventSource = new EventSource(subscriptionURL);
                    eventSourceOptions = {
                        livePersonEventSource: livePersonEventSource,
                        handleLivePersonOnMessageError: handleLivePersonOnMessageError,
                        syncChatMessage: syncLivePersonChatMessage,
                        setLivePersonAgentInitial: setLivePersonAgentInitial,
                        setLivePersonAgentName: setLivePersonAgentName,
                        setLivePersonConversationId: setLivePersonConversationId,
                        setCachedMessages: setCachedMessages,
                        setStreamingText: setStreamingText,
                        setErrorMessage: setErrorMessage,
                        lpUserFirstName: lpUserFirstName,
                        lpUserLastName: lpUserLastName,
                        chatCustomerId: chatCustomerId,
                        submitMessageURL: submitMessageURL,
                        setIsLivePersonEnabled: setIsLivePersonEnabled,
                        setIsLivePersonSessionActive: setIsLivePersonSessionActive,
                        setCloseLpChat: setCloseLpChat,
                    };
                    // Start handle Server side event from LP connector service
                    return [4 /*yield*/, handleEventsFromLivePerson(eventSourceOptions)];
                case 1:
                    // Start handle Server side event from LP connector service
                    _a.sent();
                    lpData = {
                        messageType: MESSAGE_TYPE.OPEN,
                        productId: productId,
                    };
                    livePersonMessagePayload = {
                        chatCustomerId: chatCustomerId,
                        user: {
                            firstName: lpUserFirstName,
                            lastName: lpUserLastName,
                        },
                        lpData: lpData,
                        msgId: uuidV4(),
                    };
                    requestOptions = {
                        url: submitMessageURL,
                        headers: {},
                    };
                    submitOPENMessageOptions = {
                        requestOptions: requestOptions,
                        livePersonMessagePayload: livePersonMessagePayload,
                        handleLivePersonOnMessageError: handleLivePersonOnMessageError,
                    };
                    return [4 /*yield*/, submitMessageToLivePerson(submitOPENMessageOptions)];
                case 2:
                    errorMessage = (_a.sent()).errorMessage;
                    setIsDisablingInputValue(false);
                    contentSeparatorMessage = {
                        role: 'chatContentSeparator',
                        content: 'Transfer to Live Agent',
                        key: 'connectingToAgent',
                    };
                    // display the chat content separator
                    setChatMessage(__spreadArray(__spreadArray([], chatMessages, true), [contentSeparatorMessage], false));
                    setCachedMessages(contentSeparatorMessage);
                    // Log the initiate agent event
                    initiateAgentlog();
                    if (errorMessage) {
                        setErrorMessage(errorMessage);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [isLivePersonEnabled, lpUserFirstName, lpUserLastName, chatMessages, isLivePersonSessionActive]);
};
//# sourceMappingURL=useLivePersonConnectionRequest.js.map